import { createAction, props } from '@ngrx/store';
import {
  CustomVendorReportingOverviewList,
  CustomVendorReportingSearchFilters,
  VendorReportTransferData,
  VendorReportingDetailData,
  VendorReportingDetailResponse,
  VendorReportingDetailResultsData,
} from '../custom-vendor-reporting.models';

export const getVendorReportingOverview = createAction(
  '[Custom Vendor Reporting] get vendor reporting overview',
  props<{
    searchFilters: CustomVendorReportingSearchFilters;
  }>()
);

export const getVendorReportingOverviewSuccess = createAction(
  '[Custom Vendor Reporting] get vendor reporting overview success',
  props<{ vendorReportingOverview: CustomVendorReportingOverviewList }>()
);

export const getVendorReportingOverviewFailure = createAction(
  '[Custom Vendor Reporting] get vendor reporting overview failure',
  props<{ error: Error }>()
);

// *****************************************************

export const clearVendorReportingOverview = createAction(
  '[Custom Vendor Reporting] clear vendor reporting overview'
);

export const clearVendorReportingSearchFilters = createAction(
  '[Custom Vendor Reporting] clear vendor reporting Search Filters'
);

// *****************************************************

// *****************************************************

export const getVendorReportingDetails = createAction(
  '[Custom Vendor Reporting] get vendor reporting details',
  props<{
    reportTransferData: VendorReportTransferData;
  }>()
);

export const getVendorReportingDetailsSuccess = createAction(
  '[Custom Vendor Reporting] get vendor reporting details success',
  props<{ vendorReportingDetails: VendorReportingDetailResponse }>()
);

export const getVendorReportingDetailsFailure = createAction(
  '[Custom Vendor Reporting] get vendor reporting details failure',
  props<{ error: Error }>()
);


// *****************************************************

export const updateVendorReportingDetails = createAction(
  '[Custom Vendor Reporting] update vendor reporting details',
  props<{
    reportTransferData: VendorReportTransferData;
    VendorReportingDetailsList: VendorReportingDetailData[];
  }>()
);

export const updateVendorReportingDetailsSuccess = createAction(
  '[Custom Vendor Reporting] update vendor reporting details success'
);

export const updateVendorReportingDetailsFailure = createAction(
  '[Custom Vendor Reporting] update vendor reporting details failure',
  props<{
    errorMessage: VendorReportingDetailResultsData[];
  }>()
);

export const updateVendorReportingDetailsReset = createAction(
  '[Custom Vendor Reporting] update vendor reporting details reset'
);


// *****************************************************

export const deleteVendorReportingDetails = createAction(
  '[Custom Vendor Reporting] delete vendor reporting details',
  props<{
    reportTransferData: VendorReportTransferData;
    VendorReportingDetailsList: VendorReportingDetailData[];
  }>()
);

export const deleteVendorReportingDetailsSuccess = createAction(
  '[Custom Vendor Reporting] delete vendor reporting details success'
);

export const deleteVendorReportingDetailsFailure = createAction(
  '[Custom Vendor Reporting] delete vendor reporting details failure'
);

export const deleteVendorReportingDetailsReset = createAction(
  '[Custom Vendor Reporting] delete vendor reporting details reset'
);

// *****************************************************


export const getRioDataEvaluationOverview = createAction(
  '[Custom Vendor Reporting] get rio data evaluation overview',
  props<{
    searchFilters: CustomVendorReportingSearchFilters;
  }>()
);

export const getRioDataEvaluationOverviewSuccess = createAction(
  '[Custom Vendor Reporting] get rio data evaluation overview success',
  props<{ vendorReportingOverview: CustomVendorReportingOverviewList }>()
);

export const getRioDataEvaluationOverviewFailure = createAction(
  '[Custom Vendor Reporting] get rio data evaluation overview failure',
  props<{ error: Error }>()
);

export const clearRioDataEvaluationOverview = createAction(
  '[Custom Vendor Reporting] clear rio data evaluation overview'
);

export const clearRioDataEvaluationOverviewSearchFilters = createAction(
  '[Custom Vendor Reporting] clear rio data evaluation Search Filters'
);